export default __webpack_public_path__ + "static/media/proshows-bg.a1882123.jpg";